import { useState } from 'react';
import "./essay.css";

const EssayEditingServices = () => {
  const [selectedEssay, setSelectedEssay] = useState(null);

  const essayData = [
    {
      id: 1,
      title: "Common Application Essay",
      shortDescription: "Perfect for students applying to American universities through the Common App platform.",
      fullContent: `The common application essay editing service is perfect for students applying their SAT for American University application essay from different countries. The editing service covers all aspects of common application essay writing. The editing service also includes checking for excellent educational and experiential records that can help you with your college application essay. They understand the dynamics of American college admissions and what they are looking for in terms of being fit for success too. The experts at EngageHub have mastered the perfect essay. They understand the various crucial elements that make up a successful common application essay. The editing service also includes writing being the crux of thoughts, removing redundancy or improving the questions asked, they understand essay writing service at EngageHub covers all aspects of common application essay writing. The editing service also includes checking the personal and purpose of important answers.`,
      perfectFor: ["American university applications"],
      includes: [
        "Working with an expert editor",
        "Structural review, reference list support and review",
        "Grammar, diction and syntax review"
      ]
    },
    {
      id: 2,
      title: "Research Paper (Dissertation)",
      shortDescription: "Comprehensive editing for undergraduate and master's level research papers and dissertations.",
      fullContent: `The essay editing and proofreading services offered by EngageHub for Research Papers (Dissertation) are flexible, covering all aspects that make a research paper comprehensive and well-structured. The editing service covers all aspects of research paper writing. The editing services is broadly provided to ensure that the entire write-up is coherent and well-formed. The editing services of dissertations at EngageHub covers all aspects of research paper writing. The editing service also includes checking for consistency in writing style, tone, and approach. The expert editors at EngageHub have helped hundreds of scholars with their paper submissions in our time period, we have also developed the knack of understanding what academic institutions expect from research papers submitted in their portals.`,
      perfectFor: [
        "Undergraduate dissertation for Masters Programs",
        "Master's dissertation"
      ],
      includes: [
        "Review of structure and logical progression",
        "Review of bibliography",
        "Matching grammar, diction and syntax"
      ]
    },
    {
      id: 3,
      title: "Personal Statement Enhancement",
      shortDescription: "Specialized editing for UCAS personal statements for UK university applications.",
      fullContent: `The personal statement is required for admissions for the UK UCAS university portal. The Personal Statement should represent what you are as a person and what you want to achieve in your career. The personal statement is a crucial part of your university application. The personal statement should be written in the course you are applying for. The UCAS personal statement varies from the common essays in many key criteria, but also they have to follow the entire thought process consolidated. The personal statement writing requires an expert guidance and expert assistance. The personal statement should represent what you are as a person and what you want to achieve in your career. The personal statement is a crucial part of your university application. The personal statement should be written in the course you are applying for. The UCAS writing style and understand what makes real writing credible and admission worthy.`,
      perfectFor: ["Personal Statement for UCAS"],
      includes: [
        "Working with an expert college essay editor",
        "Structural review, improvement, suggestions, References, and Appendices"
      ]
    }
  ];

  const openModal = (essay) => {
    setSelectedEssay(essay);
  };

  const closeModal = () => {
    setSelectedEssay(null);
  };

  return (
    <div className="essay-editing-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Essay Editing Services</h1>
          <p>Get Essay Writing Help from Professionals</p>
          <a href="/contact">
            <button className="cta-button">Contact Us</button>
          </a>
        </div>
      </section>

      {/* Main Content */}
      <div className="main-content">
        <div className="container">
          {/* How Important is the College Essay Section */}
          <section className="college-essay-importance">
            <div className="content-with-image">
              <div className="text-content">
                <h2>How Important is the College Essay in the Selection Process?</h2>
                <p>
                  College essays are one of the most important parts of the college application process. This is a must for admissions in various colleges and universities in Europe and America. Students realize these have been a global shift in the beginning of College Essays in an acceptance process. The college essay is considered as one of the most important factors that they actually feel the knowledge gaps, the maturity of thought and the overall mental ability of the applicants. Further there is no one of the most difficult comes to college essays. There is no fixed pattern to write a college essay. The college essay is written in a detailed and explanatory format.
                </p>
                <p>
                  The college essay is important - they have more details answering the question asked in a personal manner through a well-structured and logical response.
                </p>
              </div>
              <div className="image-content">
                <img src="/essay-editing-services-dubai.jpg" alt="College Essay Importance" />
              </div>
            </div>
          </section>

          <section className="services-section">
            <h2>Why do we need to edit the college admissions essay?</h2>
            <p>
              Most of the students make mistakes while writing essays such as having the fear of thought or choosing a completely inappropriate direction. Students often get confused about what to write and how to write. Writing Essay writing services is one thing that should not be ignored.
            </p>
            <p>Reasons to go for essay editing help:</p>

            <ul className="services-list">
              <li>Expert Guidance for Clarity & Impact</li>
              <li>Polished, Engaging, and Authentic Writing</li>
              <li>Higher Acceptance Confidence</li>
            </ul>

            
          </section>

          {/* Two Column Section /}
          <section className="two-column-section">
            <div className="column">
              <h3>College Essays - An overview</h3>
              <p>
                The colleges provides the essay prompt or guidance for students to write their college essays. The college essays are statement specific courses. These questions are designed to test the candidates' abilities and be judged for course admissions. The college essay is extremely important as it provides the admissions an elimination phase of the admission process. This is why it is a highly crucial step in the admission process.
              </p>

              <h4>Types of Essays</h4>
              <p>Several topics and the questions are based:</p>
              <ul>
                <li>Argumentative Essay</li>
                <li>Creative Progression</li>
                <li>Factual</li>
                <li>Analytical</li>
                <li>Challenging Situations</li>
                <li>Ethical Reasoning</li>
                <li>Personal Experience</li>
              </ul>

              <p>Essay topics based on word limits:</p>
              <ul>
                <li>Very short write-ups: 50 to 200 words</li>
                <li>Short Essays: 200 to 500 words</li>
                <li>Long Essays: 500 to 800 words</li>
                <li>Full-length essays: More than 800 Words</li>
              </ul>
            </div>

            <div className="column">
              <h3>Why do we need to edit the college admissions essay?</h3>
              <p>
                Most of the students make mistakes while writing essays such as having the fear of thought or choosing a completely inappropriate direction. Students often get confused about what to write and how to write. Writing Essay writing services is one thing that should not be ignored.
              </p>

              <h4>Reasons to go for essay editing help:</h4>
              <ul>
                <li>Lack of clarity by admission experts having decades experience</li>
                <li>Coherent write-ups that are engaging without being controversial</li>
                <li>Write-ups filling the answering premises of the question and topics</li>
                <li>Avoiding negative chances of rejection</li>
              </ul>

              <p>
                EngageHub provides a complete admission consultancy service and offers the best essay writing services. With a team of experienced consultants, EngageHub has been a pioneer in a business that has covered a highly detailed niche for itself.
              </p>
            </div>
          </section>

          {/* Services Section /}
          <section className="services-section">
            <h2>EngageHub Essay Editing Services - What can we edit for you?</h2>
            <p>
              We help students apply editing help on all university colleges and courses seeking for various application levels in mind. Our college essay editing services span beyond grammar and spelling.
            </p>
            <p>The college essay editing services at EngageHub comprises:</p>

            <ul className="services-list">
              <li>Brainstorming of ideas</li>
              <li>Structuring content</li>
              <li>Developing initial drafts</li>
              <li>Polishing and proofreading</li>
              <li>Assistance with application and learning issues</li>
              <li>Sentence fragments tailored to perfection</li>
              <li>Tackling run-on sentences</li>
              <li>Improving flow and readability</li>
              <li>Tone and style improvement</li>
              <li>Checking and correcting the flow, accuracy of thought and consistency in the write-up</li>
              <li>Obtain content and structure editing</li>
            </ul>
          </section>

          {/* Essay Types Section - NEW CARD LAYOUT */}
          <section className="essay-types-section">
            <h2>Essay Editing Services from EngageHub</h2>
            <p>At EngageHub, we offer editing services for different types of essays.</p>

            <div className="essay-cards-container">
              {essayData.map((essay) => (
                <div key={essay.id} className="essay-card">
                  <h3>{essay.title}</h3>
                  <p className="card-description">{essay.shortDescription}</p>
                  <button 
                    className="view-more-btn"
                    onClick={() => openModal(essay)}
                  >
                    View More
                  </button>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>

      {/* Modal */}
      {selectedEssay && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              &times;
            </button>
            <h2>{selectedEssay.title}</h2>
            <div className="modal-body">
              <p>{selectedEssay.fullContent}</p>
              
              <h4>Perfect for:</h4>
              <ul>
                {selectedEssay.perfectFor.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>

              <h4>Includes:</h4>
              <ul>
                {selectedEssay.includes.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EssayEditingServices;